// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store'
import { BrowserRouter } from 'react-router-dom';

// Suppress benign ResizeObserver loop errors (triggered by Recharts ResponsiveContainer)
// This error is a known browser issue and doesn't affect functionality
if (typeof window !== "undefined") {
  // Method 1: Capture phase event listener
  const ignoreResizeObserverError = (event) => {
    const msg = event?.message || event?.reason?.message || "";
    if (
      msg.includes("ResizeObserver loop completed with undelivered notifications") ||
      msg.includes("ResizeObserver loop limit exceeded")
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return true;
    }
  };
  
  window.addEventListener("error", ignoreResizeObserverError, true);
  window.addEventListener("unhandledrejection", ignoreResizeObserverError, true);
  
  // Method 2: Override window.onerror for CRA error overlay
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (
      message?.includes?.("ResizeObserver loop") ||
      error?.message?.includes?.("ResizeObserver loop")
    ) {
      return true; // Suppress the error
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')

);
